import MuiButton from './MuiButton';
import MuiIconButton from './MuiIconButton';
import MuiPaper from './MuiPaper';
import MuiTableCell from './MuiTableCell';
import MuiTableHead from './MuiTableHead';
import MuiTypography from './MuiTypography';
import MuiStepIcon from './MuiStepIcon';
import MuiStepConnector from './MuiStepConnector';
import MuiInputBase from './MuiInputBase';

const withStyleOverrides = (styleOverrides) => ({ styleOverrides });

export default {
  MuiButton: withStyleOverrides(MuiButton),
  MuiIconButton: withStyleOverrides(MuiIconButton),
  MuiPaper: withStyleOverrides(MuiPaper),
  MuiTableCell: withStyleOverrides(MuiTableCell),
  MuiTableHead: withStyleOverrides(MuiTableHead),
  MuiTypography: withStyleOverrides(MuiTypography),
  MuiStepIcon: withStyleOverrides(MuiStepIcon),
  MuiStepConnector: withStyleOverrides(MuiStepConnector),
  MuiInputBase: withStyleOverrides(MuiInputBase),
};
